export const phoneRe = /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/
